export default __webpack_public_path__ + "static/media/new.bf58bec8.svg";